import { api } from "./api";

/** Feed agregado del ecosistema ("toda la Familia"). */
export async function fetchActividadFeed(limite = 40) {
  const { data } = await api.get("/actividad/feed", { params: { limite } });
  return data;
}
